import * as React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Grid } from '@mui/material';

function GridItem1() {
  return (
    // From 0 to 600px wide (smart-phones), I take up 12 columns, or the whole device width!
    // From 600-690px wide (tablets), I take up 6 out of 12 columns, so 2 columns fit the screen.
    // From 960px wide and above, I take up 25% of the device (3/12), so 4 columns fit the screen.
    <Grid item xs={12} sm={6} md={6}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px dotted'
          //maxWidth: 600
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <Typography
            style={{
              color: '#021D4E',
              fontWeight: '800',
              fontSize: 14,
              textAlign: 'center'
            }}>
            Front copy of my insurance card
          </Typography>
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Box>
        <Typography
          style={{
            color: '#021D4E',
            fontWeight: '500',
            fontSize: 12,
            textAlign: 'center'
          }}>
          insuranceCardFront.png
        </Typography>
        <a href="insuranceCardFront.png" target="_blank" rel="noopener noreferrer">
          <Box
            component="img"
            src={require('../../../images/insuranceCardFront.png')}
            //style={{ width: 300, height: 200 }}
          />
        </a>
      </Box>
    </Grid>
  );
}
function GridItem2() {
  return (
    // From 0 to 600px wide (smart-phones), I take up 12 columns, or the whole device width!
    // From 600-690px wide (tablets), I take up 6 out of 12 columns, so 2 columns fit the screen.
    // From 960px wide and above, I take up 25% of the device (3/12), so 4 columns fit the screen.
    <Grid item xs={12} sm={6} md={6}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px dotted'
          //maxWidth: 600
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <Typography
            style={{
              color: '#021D4E',
              fontWeight: '800',
              fontSize: 14,
              textAlign: 'center'
            }}>
            Back copy of my insurance card
          </Typography>
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Box>
        <Typography
          style={{
            color: '#021D4E',
            fontWeight: '500',
            fontSize: 12,
            textAlign: 'center'
          }}>
          insuranceCardBack.png
        </Typography>
        <a href="insuranceCardBack.png" target="_blank" rel="noopener noreferrer">
          <Box
            component="img"
            src={require('../../../images/insuranceCardBack.png')}
            //style={{ width: 300, height: 200 }}
          />
        </a>
      </Box>
    </Grid>
  );
}
function GridItem3() {
  return (
    // From 0 to 600px wide (smart-phones), I take up 12 columns, or the whole device width!
    // From 600-690px wide (tablets), I take up 6 out of 12 columns, so 2 columns fit the screen.
    // From 960px wide and above, I take up 25% of the device (3/12), so 4 columns fit the screen.
    <Grid item xs={12} sm={6} md={6}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px dotted'
          //maxWidth: 600
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <Typography
            style={{
              color: '#021D4E',
              fontWeight: '800',
              fontSize: 14,
              textAlign: 'center'
            }}>
            Registration form
          </Typography>
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Box>
        <Typography
          style={{
            color: '#021D4E',
            fontWeight: '500',
            fontSize: 12,
            textAlign: 'center'
          }}>
          registrationform.pdf
        </Typography>
        <a href="registrationform.pdf" target="_blank" rel="noopener noreferrer">
          <Box
            component="img"
            src={require('../../../images/pdf.png')}
            //style={{ width: 300, height: 200 }}
          />
        </a>
      </Box>
    </Grid>
  );
}
function GridItem4() {
  return (
    // From 0 to 600px wide (smart-phones), I take up 12 columns, or the whole device width!
    // From 600-690px wide (tablets), I take up 6 out of 12 columns, so 2 columns fit the screen.
    // From 960px wide and above, I take up 25% of the device (3/12), so 4 columns fit the screen.
    <Grid item xs={12} sm={6} md={6}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px dotted'
          //maxWidth: 600
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <Typography
            style={{
              color: '#021D4E',
              fontWeight: '800',
              fontSize: 14,
              textAlign: 'center'
            }}>
            Medical release form
          </Typography>
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Box>
        <Typography
          style={{
            color: '#021D4E',
            fontWeight: '500',
            fontSize: 12,
            textAlign: 'center'
          }}>
          releaseform.pdf
        </Typography>
        <a href="registrationform.pdf">
          <Box
            component="img"
            src={require('../../../images/pdf.png')}
            //style={{ width: 300, height: 200 }}
          />
        </a>
      </Box>
    </Grid>
  );
}

export default function UploadFileCardCard() {
  return (
    <Box>
      {false && (
        <Card sx={{ maxWidth: 345 }}>
          <CardMedia
            component="img"
            height="194"
            image="../../images/insuranceCardFront.png"
            alt="Insurance card front"
          />
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              This is font of insurance card
            </Typography>
          </CardContent>
          <CardActions disableSpacing>
            <IconButton aria-label="delete">
              <DeleteIcon />
            </IconButton>
          </CardActions>
        </Card>
      )}
      <Grid container spacing={1}>
        <GridItem1 />
        <GridItem2 />
        <GridItem3 />
        <GridItem4 />
      </Grid>
    </Box>
  );
}
